import { render, staticRenderFns } from "./RoleDist.vue?vue&type=template&id=238ee60d&"
import script from "./RoleDist.vue?vue&type=script&lang=js&"
export * from "./RoleDist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/build-jeepay-web-mch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('238ee60d')) {
      api.createRecord('238ee60d', component.options)
    } else {
      api.reload('238ee60d', component.options)
    }
    module.hot.accept("./RoleDist.vue?vue&type=template&id=238ee60d&", function () {
      api.rerender('238ee60d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sysuser/RoleDist.vue"
export default component.exports